import { render, staticRenderFns } from "./productMooc.vue?vue&type=template&id=e545a506&"
import script from "./productMooc.vue?vue&type=script&lang=js&"
export * from "./productMooc.vue?vue&type=script&lang=js&"
import style0 from "./productMooc.vue?vue&type=style&index=0&id=e545a506&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports